import fileSize from "filesize";
import Intro from "./Intro";
import FileIcon from "./FileIcon";
import Container from "./Container";
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import IconDelete from "../public/images/delete-2.svg";
import IconDownload from "../public/images/download.svg";
import { useCallback } from "react";
import ActionsGrid from "./ActionsGrid";
import { sendEvent } from "../utils/analytics";

export const Result = ({t, result, route, actions = {}}) => {
    const handleDownloadClick = useCallback((event) => {
    event.preventDefault();
    saveAs(event.currentTarget.href, event.currentTarget.download);

    sendEvent({
        category: 'file-table',
        action: 'download-click',
        label: 'pdf',
    });
    }, []);
    return (
        <>
            <Intro
            className="mb-xs-3"
            title={t('convert-and-edit:editing.ready-title')}
            titleClassName="h2"
            text={t('convert-and-edit:editing.ready-text')}
            />
            <Container className="result-pdf-container__main">
                <div className="result-pdf-container">
                <div className="result-pdf-info">
                    <div className="result-pdf-info-title">
                    <FileIcon type={result.fileType}/>
                    <span>{result.fileName}</span>
                    </div>
                    <span>({fileSize(result.fileSize)})</span>
                </div>
                {result.alreadyOptimized && (
                    <p className="result-pdf-note">
                        {t('convert-and-edit:file-table.already-optimized')}
                    </p>
                )}
                <a className="result-pdf-link" href={result.fileUrl} onClick={handleDownloadClick} download={result.fileName}
                    target="_blank" rel="noreferrer">
                    <IconDownload className="result-pdf-link-icon"/>
                    <span>{t('convert-and-edit:file-table.download')}</span>
                </a>
                </div>
                <ActionsGrid className="result-pdf-actions-grid"
                title={t('common:cards.title')}
                {...actions}
                />
            </Container>
            {
                route && (
                    <div className="result-link-container">
                    <a className="link-button" href={route}>
                        <span>{t('convert-and-edit:delete-file')}</span>
                        <IconDelete className="result-link-icon"/>
                    </a>
                    </div>
                )
            }
        </>
    )
}
Result.propTypes = {
    t: PropTypes.func.isRequired,
    result: PropTypes.shape({
        fileName: PropTypes.string.isRequired,
        fileSize: PropTypes.number.isRequired,
        fileUrl: PropTypes.string.isRequired,
        fileType: PropTypes.string.isRequired,
        alreadyOptimized: PropTypes.bool,
    }).isRequired,
    route: PropTypes.string,
    actions: PropTypes.object,
}